<template>
  <div>
    <ExtendExpiredAtModal
      :isOpen="openModal.extendExpiredAt"
      :close="closeExtendModal"
      :lessonAccess="selectedLessonAccess"
      :reload="reload"
      v-if="openModal.extendExpiredAt"
    />
    <ExcelExtendResultModal
      :isOpen="openModal.extendResult"
      :close="closeResultModal"
      :failResult="failResult"
      :successResult="successResult"
      v-if="openModal.extendResult"
    />
    <CreateAccountModal
      :isOpen="openModal.createAccount"
      :close="handleClickCreateAccountButton"
      :reload="reload"
      lessonAccountOption="REQUEST_CONSULTING"
      v-if="openModal.createAccount"
    />
    <BulkAccountModal
      :isOpen="openModal.bulkAccount"
      :close="handleClickBulkAccountButton"
      :reload="reload"
      lessonAccountOption="REQUEST_CONSULTING"
      v-if="openModal.bulkAccount"
    />
    <EditLessonAccessModal
      :isOpen="openModal.editUser"
      :close="handleClickEditLessonAccess"
      :reload="reload"
      :lessonAccess="selectedLessonAccess"
      v-if="openModal.editUser"
    />
    <div class="inline-block min-width-full rounded-lg shadow bg-white p-4">
      <div class="inline-flex justify-start items-center gap-2">
        <VueDatePicker
          v-model="search.searchStartDate"
          format="yyyy-MM-dd HH:mm:ss"
          :clearable="true"
          placeholder="검색 시작일"
          auto-apply
          vertical
        />
        <VueDatePicker
          v-model="search.searchEndDate"
          format="yyyy-MM-dd HH:mm:ss"
          :clearable="true"
          placeholder="검색 종료일"
          auto-apply
        />
      </div>
      <div class="my-2">
        <b-input-group class="max-w-2xl">
          <b-form-input
            id="inline-form-input-name"
            class=" mr-sm-2 md-4"
            placeholder="이름 또는 학생코드, 전화번호를 입력하세요."
            v-model="search.keyword"
            v-on:keyup.enter="handleSearch"
          ></b-form-input>
          <b-input-group-append>
            <button class="btn btn-primary" v-on:click="handleSearch">검색</button>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div class="inline-flex justify-end w-full gap-2 flex-wrap">
        <Button :type="ButtonTypes.navy" :label="`${lessonAccessAccountType === 'BASIC_CLASS' ? '' : '실전반'} 대량 학생코드 생성`" :onClick="handleClickBulkAccountButton" />
        <Button :type="ButtonTypes.purple" :label="`${lessonAccessAccountType === 'BASIC_CLASS' ? '' : '실전반'} 개별 학생코드 생성`" :onClick="handleClickCreateAccountButton" />
        <Button :type="ButtonTypes.green" :label="`${lessonAccessAccountType === 'BASIC_CLASS' ? '' : '실전반'} 학생 코드 다운로드`" :onClick="exportExcel" :loading="loading.exportExcel"/>
      </div>
      <div class="text-right mt-2">
        <a 
          target="_blank"
          href="https://kr1-api-object-storage.nhncloudservice.com/v1/AUTH_da85f98cb1f94dc3bf65403e1e6e1b23/sample/sample.xlsx">학생코드 생성 샘플 다운로드</a>
      </div>
      <b-table :busy="isLoading" :fields="fields" :items="lessonAccesses" class="mt-4 min-width-full">
        <template #cell(createdAt)="data">
          {{ getDate(data.item.createdAt)}}
        </template>
        <template #cell(startedAt)="data">
          {{ getDate(data.item.startedAt)}}
        </template>
        <template #cell(expiredAt)="data">
          {{ getDate(data.item.expiredAt)}}
        </template>
        <template #cell(manageExpiredAtButton)="data">
          <button class="btn btn-warning text-white"  @click="extendExpiredDate(data.item)">연장</button>
        </template>
        <template #cell(buttons)="data" >
          <div class="inline-flex gap-2 justify-end w-full">
            <Button :type="ButtonTypes.yellow" label="수정" :on-click="() => openEditUser(data.item)"/>
            <button class="btn btn-danger" @click="deleteAuth(data.item)">권한 삭제</button>
          </div>
        </template>
        <template #cell(lessonLog)="data">
          {{ data.item.lastUnlockLessonContentTitle ? `${data.item.lastUnlockLessonContentTitle}+${data.item.leasUnlockDdays}` : ''}}
        </template>
        <template #cell(accountType)="data">
          <b-badge variant="success" v-if="data.item.accountType === 'ADVANCED_CLASS'">
            {{"실전반"}}
          </b-badge>
          <b-badge variant="primary" v-if="data.item.accountType === 'REQUEST_CONSULTING'">
            {{"기초반"}}
          </b-badge>
        </template>
        <template #cell(lessonAccessAttendanceStatusName)="data">
          <b-form-checkbox
            v-model="updateNotification"
            :value="data.item.id"
          >
            {{data.item.lessonAccessAttendanceStatusName}}
          </b-form-checkbox>
        </template>
        <template #table-busy>
          <div class="text-center text-primary">
            <b-spinner small type="grow"></b-spinner> Loading...
          </div>
        </template>
      </b-table>
      <b-pagination
        align="center"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="pageSize"
        @page-click="changePage"
      />
    </div>
  </div>
</template>
<script>
import api from "@/api/api"
import customDate from "@/util/custom-date"
import Excel from "@/util/excel";
import ExcelExtendResultModal from "@/components/modals/ExcelExtendResultModal.vue";
import ExtendExpiredAtModal from "@/components/modals/ExtendExpiredAtModal.vue";
import Button from "@/components/Button.vue";
import {ButtonTypes} from "@/util/enums";
import CreateAccountModal from "@/components/modals/CreateAccountModal.vue";
import moment from "moment/moment";
import BulkAccountModal from "@/components/modals/BulkAccountModal.vue";
import EditLessonAccessModal from "@/components/modals/EditLessonAccessModal.vue";

export default {
  computed: {
    ButtonTypes() {
      return ButtonTypes
    }
  },
  components: {
    EditLessonAccessModal,
    BulkAccountModal, Button, ExcelExtendResultModal, ExtendExpiredAtModal, CreateAccountModal},
  data() {
    return {
      isLoading: false,
      searchStartDate: null,
      searchEndDate: null,
      currentPage: 1,
      pageSize:30,
      totalPage: 0,
      totalRows: 0,
      search: {
        keyword: null,
        status: [],
      },
      fields: [
        {
          label: '생성일자',
          key: 'createdAt',
        },
        {
          label: '학생코드',
          key: 'accessCode',
        },
        {
          label: '강의명',
          key: 'lessonTitle',
        },
        {
          label: '이름',
          key: 'name',
        },
        {
          label: '전화번호',
          key: 'phoneNumber',
        },
        {
          label: '',
          key: 'buttons',
        }
      ],
      lessonAccesses: [],
      selectedLessonAccess: {},
      setting: {
        mode: 'tags',
        value: [],
        closeOnSelect: false,
        placeholder: '수강현황',
        options: [
          {value: 'NORMAL', label: '정상'},
          {value: 'FIRST_LESSON_WARNING', label: '최초경고'},
          {value: 'FIRST_LESSON_WARNING_REMIND', label: '1차 리마인드'},
          {value: 'FIRST_MISSION_WARNING', label:'1차 미션 경고'},
          {value: 'FIRST_MISSION_KICK_OUT', label:'1차 미션 강퇴'},
          {value: 'SECOND_MISSION_WARNING', label:'2차 미션 경고'},
          {value: 'SECOND_MISSION_KICK_OUT', label:'2차 미션 강퇴'},
          {value: 'THIRD_MISSION_WARNING', label:'3차 미션 경고'},
          {value: 'THIRD_MISSION_KICK_OUT', label:'3차 미션 강퇴'},
          {value: 'NOTIFICATION_COMPLETE', label:'경고완료'},
        ],
        searchable: true,
        createOption: true
      },
      updateNotification: [],
      successResult: [],
      failResult: [],
      openModal: {
        extendExpiredAt: false,
        extendResult: false,
        createAccount: false,
        bulkAccount: false,
        editUser: false
      },
      loading: {
        exportExcel: false
      },
    }
  },
  props: ["lessonAccessAccountType"],
  mounted() {
    // URL query params에서 상태 복원
    const query = this.$route.query
    if (query.page) {
      this.currentPage = parseInt(query.page)
    }
    if (query.keyword) {
      this.search.keyword = query.keyword
    }
    if (query.searchStartDate) {
      this.search.searchStartDate = new Date(query.searchStartDate)
    }
    if (query.searchEndDate) {
      this.search.searchEndDate = new Date(query.searchEndDate)
    }
    if (query.status) {
      this.search.status = query.status.split(',')
    }
    
    this.getPagingList(this.currentPage)
    this.getLessons()
  },
  methods: {
    handleClickCreateAccountButton() {
      this.openModal.createAccount = !this.openModal.createAccount
    },
    handleClickBulkAccountButton() {
      this.openModal.bulkAccount = !this.openModal.bulkAccount
    },
    handleClickEditLessonAccess () {
      this.openModal.editUser = !this.openModal.editUser
      this.selectedLessonAccess = null
    },
    getLessons() {
      api.lesson.lessons({}, (response) => {
        this.lessonOptions = [
          {value: 0, text: "없음"}
        ].concat(
          response.data.map(lesson => {
            return {value: lesson.id, text: lesson.title}
          }))
      })
    },
    deleteAuth(lessonAccess) {
      this.$store.dispatch('modal/openModal', {
        type: 'warning',
        title: '접속 권한 삭제',
        html: `${lessonAccess.name}님의 접속 권한을 삭제합니다.`,
        confirm: () => {
          api.lessonAccesses.setUnapproved({manageCode: lessonAccess.manageCode}, _ => {
            this.$toast.show('삭제 완료',
              {
                position: "top-right",
                duration: 2000
              })
            this.getPagingList(1)
          })
        }
      });
    },
    extendExpiredDate(lessonAccess) {
      this.selectedLessonAccess = lessonAccess
      this.openModal.extendExpiredAt = !this.openModal.extendExpiredAt
    },
    openEditUser(lessonAccess) {
      this.selectedLessonAccess = lessonAccess
      this.openModal.editUser = !this.openModal.editUser
    },
    getDate(date) {
      return customDate.stringFormat(date)
    },
    reload() {
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    handleSearch() {
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    changePage(event, page){
      this.currentPage = page
      this.updateQueryParams()
      this.getPagingList(this.currentPage)
    },
    updateQueryParams() {
      const query = {
        page: this.currentPage.toString()
      }
      
      if (this.search.keyword) {
        query.keyword = this.search.keyword
      }
      if (this.search.status && this.search.status.length > 0) {
        query.status = this.search.status.join(',')
      }
      if (this.search.searchStartDate) {
        query.searchStartDate = this.search.searchStartDate.toISOString()
      }
      if (this.search.searchEndDate) {
        query.searchEndDate = this.search.searchEndDate.toISOString()
      }
      
      this.$router.replace({ query })
    },
    getPagingList(page) {
      const params = {
        page: page,
        status: this.search.status,
        keyword: this.search.keyword,
        lessonAccessType: "INDIVIDUAL",
        lessonAccessAccountType: this.lessonAccessAccountType,
        searchStartDate: (this.search.searchStartDate && moment(this.search.searchStartDate).format('yyyy-MM-DD HH:mm:ss')) || null,
        searchEndDate: ( this.search.searchEndDate && moment(this.search.searchEndDate).format('yyyy-MM-DD HH:mm:ss')) || null,
      }
      this.isLoading = true
      this.lessonAccesses = []
      api.lessonAccesses.getLessonAccesses(params, (response) => {
        const {content, totalElements, totalPages} = response.data
        this.lessonAccesses = content
        this.totalRows = totalElements
        this.totalPage = totalPages
        this.currentPage = page
        this.isLoading = false
      })
    },
    exportExcel() {
      this.loading.exportExcel = true
      const params = {
        status: this.search.status,
        keyword: this.search.keyword,
        lessonAccessType: "INDIVIDUAL",
        lessonAccessAccountType: this.lessonAccessAccountType,
        searchStartDate: (this.search.searchStartDate && moment(this.search.searchStartDate).format('yyyy-MM-DD HH:mm:ss')) || null,
        searchEndDate: ( this.search.searchEndDate && moment(this.search.searchEndDate).format('yyyy-MM-DD HH:mm:ss')) || null,
      }
      api.lessonAccesses.exelExportLessonAccess(params, (response) => {
        Excel.download(response.data, '강의계정')
        this.loading.exportExcel = false
        this.$toast.show('엑셀 다운로드 완료',
          {
            position: "top-right",
            duration: 2000
          })
      }, (e) => {
        this.loading.exportExcel = false
        console.log(e)
        this.$toast.show('엑셀 다운로드 실패',
          {
            position: "top-right",
            duration: 2000
          })
      })
    },
    closeExtendModal() {
      this.openModal.extendExpiredAt = !this.openModal.extendExpiredAt
    },
    closeResultModal() {
      this.openModal.extendResult = !this.openModal.extendResult
    }
  }
}
</script>
